import { render } from "./MachineDetailsComponent.vue?vue&type=template&id=16fbbea1"
import script from "./MachineDetailsComponent.vue?vue&type=script&lang=js"
export * from "./MachineDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__